( function() {
	/**
	 * Uses youtube's js api to render and control videos on site
	 */

	var $ = require('jquery');
	var YouTubePlayer = require('youtube-player');

	// Loop through all instances of players on page
	$('.video__player').each( function( index ) {
		var player_id 	= $(this).attr('id');
		var video_id 	=  $(this).data('video-url');

		// Creates instance of each video
		var playerId = YouTubePlayer( player_id, {
 			height: '315',
 			width: '560',
			videoId: video_id,
			playerVars: {
				autoplay: 0,
				controls: 0,
				modestbranding: 1,
				enablejsapi: 1,
				autohide: 1,
				showinfo: 0,
			}
		});

		// playerId.playVideo().then(function () {
		//         console.log('Starting to play player1. It will take some time to buffer video before it starts playing.');
		// });
	});



})();
